import { Icon } from "@chakra-ui/react";
import { HiOutlineMail } from "react-icons/hi";

function Invite() {
  return <Icon as={HiOutlineMail} boxSize={5} color="gray" />;
}

export default Invite;
